import { getOrigin, getRefe } from "../utils";

export default {
  isLoading: false,
  trackClickElement: null,
  trackOnClickStart: null,
  isExceeded: false,
  origen: getOrigin(),
  refe: getRefe(),
  mock: null,
  paso1: {
    cuit: "",
    razonSocial: "",
    esPF: false,
    captcha: ""
  },
  responseConsulta: {},
  paso2: {
    camp: process.env.VUE_APP_CAMP || "",
    tipoActividad: "",
    rangoFacturacion: "",
    tipoDeCobro: "",
    lugarDeCobro: "",
    volumenDeOperaciones: ""
  },
  paso3: {
    camp: process.env.VUE_APP_CAMP || "",
    nombre: "",
    apellido: "",
    phone: { area: "", numero: "" },
    email: "",
    horario: "",
    cargoArea: ""
  },
  paso4: {
    numSucursal: "",
    dirSucursal: "",
    financiacion: false,
    cobrosPagos: false,
    seguroComercio: false
  },
  notificationToast: {
    // [info, success, alert]
    type: "",
    message: ""
  }
};
